import React, { Component } from 'react';

import { Accordion } from 'react-bootstrap';
import { FILTER_MIN_WIDTH, getFilterMaxWidth } from '../../modules/Common/globals';

// Import Style
import './Filter.scss';

class FilterPlaceholder extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.tabs = false;
    try {
      this.tabs = window.localStorage.getItem('panelTabs') === '1';
    } catch (err) {}
  }

  componentDidMount() {
    let saved;
    try {
      saved = Number(window.localStorage.getItem('filterWidth'));
    } catch (err) {}
    if (window.innerWidth <= 992 || !this.node.current) return;
    if (saved) {
      const width = Math.max(FILTER_MIN_WIDTH, Math.min(saved, getFilterMaxWidth()));
      this.node.current.style.width = `${width}px`;
      document.documentElement.style.setProperty('--filter-width', `${width}px`);
    }
  }

  renderRows(count) {
    return (
      <div className='filter-placeholder-rows'>
        {Array.from({ length: count }, (_, i) => <span key={i} className='filter-placeholder-row' />)}
      </div>
    );
  }

  render() {
    return (
      <Accordion alwaysOpen activeKey={['controls', 'filters']} className='filter filter-panel filter-panel-static filter-placeholder' ref={this.node}>
        {this.tabs && (
          <div className='filter-placeholder-tabs'>
            <span className='filter-placeholder-tab' />
            <span className='filter-placeholder-tab' />
          </div>
        )}
        <Accordion.Item eventKey="controls">
          <Accordion.Header>
            <span className='filter-placeholder-title' />
          </Accordion.Header>
          <Accordion.Body>{this.renderRows(3)}</Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="filters">
          <Accordion.Header>
            <span className='filter-placeholder-title' />
          </Accordion.Header>
          <Accordion.Body>{this.renderRows(4)}</Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  }
}
export default FilterPlaceholder;
